/**
 * Represents the duration in milliseconds to lock a profile.
 *
 * @type {number}
 */
export const deltaMsToLockProfile = 30 * 1000
